import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  const jsonLdOrg = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫漫画',
    url: 'http://adeled.com/',
    description: '韩漫漫画网站 - 免费韩国漫画下拉式在线观看平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6666',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
  };

  const jsonLdAbout = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于韩漫漫画',
    description: '韩漫漫画品牌介绍 - 致力于打造极致阅读体验的免费韩国漫画下拉式在线观看平台',
    url: 'http://adeled.com/about',
  };

  const jsonLdBreadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://adeled.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'http://adeled.com/about',
      },
    ],
  };

  return (
    <>
      <Navbar />
      <main>
        <script type="application/ld+json">{JSON.stringify(jsonLdOrg)}</script>
        <script type="application/ld+json">{JSON.stringify(jsonLdAbout)}</script>
        <script type="application/ld+json">{JSON.stringify(jsonLdBreadcrumb)}</script>

        <section className="relative w-full h-[350px] md:h-[450px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20studio%20team%20workspace%20with%20warm%20coral%20and%20amber%20lighting%2C%20creative%20office%20atmosphere%2C%20stylized%20illustration%2C%20modern%20clean%20aesthetic%2C%20editorial%20photography%20style%2C%20soft%20natural%20light%2C%20harmonious%20composition&width=1600&height=800&seq=about-hero&orientation=landscape"
            alt="关于韩漫漫画 - 品牌故事"
            title="韩漫漫画网站 - 关于我们"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-full max-w-3xl mx-auto px-4 text-center">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-3">
                关于韩漫漫画
              </h1>
              <p className="text-sm md:text-base text-background-50/70 max-w-xl mx-auto">
                致力于打造极致阅读体验的免费韩国漫画平台
              </p>
            </div>
          </div>
        </section>

        <nav className="bg-background-50 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6 py-3">
            <div className="max-w-6xl mx-auto flex items-center gap-2 text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </div>
          </div>
        </nav>

        <section className="bg-background-50 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
                <div className="lg:w-2/5">
                  <span className="inline-block px-3 py-1 rounded-lg bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
                    品牌故事
                  </span>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                    值得信赖的平台
                  </h2>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    韩漫漫画成立于2020年，是中国领先的韩国漫画在线观看平台。我们始终致力于为广大漫画爱好者提供
                    <strong className="text-foreground-800">免费韩国漫画</strong>资源，打造极致的
                    <strong className="text-foreground-800">下拉式阅读</strong>体验。
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    创始团队由一群热爱韩国漫画的年轻人组成，他们深知读者在寻找高质量
                    <strong className="text-foreground-800">韩漫在线观看</strong>资源时的痛点。
                    因此，我们汇聚了数千部优质漫画作品，覆盖浪漫爱情、热血动作、奇幻异界等多元类型，
                    致力于成为用户心中最好的<strong className="text-foreground-800">漫画网址</strong>。
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    我们坚持每日极速更新，保持200+部的日更新量，确保读者能够第一时间追到最新章节。
                    从作品筛选、翻译质量到阅读界面设计，每一个环节我们都精益求精，只为给用户带来最优质的阅读享受。
                  </p>
                </div>

                <div className="lg:w-3/5">
                  <div className="flex flex-wrap gap-4 mb-6">
                    <div className="flex-1 min-w-[140px] bg-background-100 rounded-lg p-5 text-center">
                      <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">5000+</p>
                      <p className="text-xs text-foreground-500 mt-1">部漫画资源</p>
                    </div>
                    <div className="flex-1 min-w-[140px] bg-background-100 rounded-lg p-5 text-center">
                      <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">100万+</p>
                      <p className="text-xs text-foreground-500 mt-1">活跃读者</p>
                    </div>
                    <div className="flex-1 min-w-[140px] bg-background-100 rounded-lg p-5 text-center">
                      <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">200+</p>
                      <p className="text-xs text-foreground-500 mt-1">日均更新</p>
                    </div>
                    <div className="flex-1 min-w-[140px] bg-background-100 rounded-lg p-5 text-center">
                      <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">9.4</p>
                      <p className="text-xs text-foreground-500 mt-1">平均评分</p>
                    </div>
                  </div>

                  <div className="flex gap-3">
                    <div className="w-32 h-24 rounded-lg overflow-hidden">
                      <img
                        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20creative%20team%20discussion%20with%20warm%20coral%20lighting%2C%20modern%20office%2C%20artistic%20atmosphere%2C%20stylized%20illustration%2C%20clean%20aesthetic&width=320&height=240&seq=about-img-01&orientation=landscape"
                        alt="韩漫漫画团队"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="w-40 h-56 rounded-lg overflow-hidden">
                      <img
                        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20studio%20with%20warm%20golden%20lighting%2C%20illustration%20on%20display%20screen%2C%20creative%20environment%2C%20stylized%20aesthetic%2C%20clean%20modern%20composition&width=400&height=560&seq=about-img-02&orientation=portrait"
                        alt="韩漫漫画工作室"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                    为什么选择我们
                  </h2>
                </div>
                <p className="text-sm text-foreground-500 max-w-md">
                  三大核心优势，为您打造极致的漫画阅读体验
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                <div className="bg-background-50 rounded-lg p-6">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                    <i className="ri-scroll-to-bottom-line text-xl"></i>
                  </div>
                  <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">下拉式阅读</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    独创的下拉式阅读体验，告别传统翻页模式。流畅滚动、无缝衔接，让您沉浸式享受每一部漫画作品。
                  </p>
                  <div className="mt-4 h-32 rounded-lg overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20webtoon%20scroll%20reading%20interface%20on%20mobile%2C%20warm%20coral%20accents%2C%20clean%20UI%20design%2C%20minimal%20aesthetic%2C%20soft%20lighting&width=400&height=300&seq=why-01&orientation=landscape"
                      alt="下拉式阅读体验"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="bg-background-50 rounded-lg p-6">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-hd-line text-xl"></i>
                  </div>
                  <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">高清画质</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    所有漫画均采用高清画质展示，精细的笔触和色彩还原，让每一格画面都如同艺术画作般精美绝伦。
                  </p>
                  <div className="mt-4 h-32 rounded-lg overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=High%20quality%20digital%20art%20display%2C%20crisp%20details%2C%20warm%20golden%20accents%2C%20clean%20modern%20design%2C%20minimal%20aesthetic&width=400&height=300&seq=why-02&orientation=landscape"
                      alt="高清画质"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="bg-background-50 rounded-lg p-6">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-4">
                    <i className="ri-flashlight-line text-xl"></i>
                  </div>
                  <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">实时更新</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    每日200+部漫画同步更新，第一时间追踪最新章节。专属更新提醒功能，让您不会错过任何精彩内容。
                  </p>
                  <div className="mt-4 h-32 rounded-lg overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Fast%20digital%20update%20notification%20concept%2C%20warm%20amber%20accents%2C%20clean%20modern%20UI%2C%20minimal%20aesthetic%2C%20soft%20lighting&width=400&height=300&seq=why-03&orientation=landscape"
                      alt="实时更新"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500 mb-10 max-w-xl mx-auto">
                有任何问题或建议，欢迎随时与我们联系，我们将竭诚为您服务。
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-10">
                <div className="bg-background-100 rounded-lg p-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-3">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  <p className="text-sm font-medium text-foreground-800">客服电话</p>
                  <p className="text-sm text-foreground-500 mt-1">400-888-6666</p>
                </div>
                <div className="bg-background-100 rounded-lg p-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mx-auto mb-3">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <p className="text-sm font-medium text-foreground-800">电子邮箱</p>
                  <p className="text-sm text-foreground-500 mt-1">hello@adeled.com</p>
                </div>
                <div className="bg-background-100 rounded-lg p-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mx-auto mb-3">
                    <i className="ri-map-pin-line text-lg"></i>
                  </div>
                  <p className="text-sm font-medium text-foreground-800">公司地址</p>
                  <p className="text-sm text-foreground-500 mt-1">北京市朝阳区望京SOHO T1-A座 1208室</p>
                </div>
              </div>

              <Link
                to="/category/romance"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap"
              >
                立即体验免费下拉式阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}